import { render, staticRenderFns } from "./cosa.vue?vue&type=template&id=0dd70340"
import script from "./cosa.vue?vue&type=script&lang=js"
export * from "./cosa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports